(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81564,65250],{

/***/ 81564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NoMoreDebtTodayWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/nomoredebttoday/logo/index.tsx


function NoMoreDebtTodayLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "411",
        height: "50",
        fill: "none",
        viewBox: "0 0 411 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_4)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#08C",
                        d: "M76.22 38.415h-4.947V12.273h5.077l12.387 17.671V12.273h4.948v26.135h-4.69L76.214 20.213v18.195l.007.007zM102.463 37.584a10.2 10.2 0 01-3.723-3.702c-.91-1.553-1.368-3.265-1.368-5.126 0-1.862.458-3.595 1.368-5.17a10.03 10.03 0 013.73-3.73c1.576-.91 3.308-1.368 5.206-1.368 1.897 0 3.63.458 5.205 1.375a10.135 10.135 0 013.731 3.73c.909 1.568 1.367 3.287 1.367 5.163 0 1.876-.458 3.573-1.367 5.133a9.974 9.974 0 01-3.738 3.702c-1.582.902-3.329 1.36-5.234 1.36-1.905 0-3.609-.458-5.184-1.367h.007zm8.034-3.852a5.463 5.463 0 002.019-2.076c.494-.881.745-1.855.745-2.922 0-1.067-.251-2.055-.745-2.936a5.55 5.55 0 00-2.026-2.083 5.386 5.386 0 00-2.807-.766 5.435 5.435 0 00-2.821.766 5.532 5.532 0 00-2.019 2.083c-.494.881-.745 1.862-.745 2.936 0 1.074.251 2.055.745 2.929a5.474 5.474 0 002.019 2.062c.852.501 1.79.752 2.821.752 1.031 0 1.969-.251 2.821-.752l-.007.007zM128.849 38.415h-5.077l3.179-26.135h5.693l6.265 19.103 6.251-19.103h5.692l3.201 26.156h-5.098l-1.898-18.08-5.936 18.066h-4.375l-5.936-18.065-1.969 18.065.008-.007zM161.242 37.584a10.198 10.198 0 01-3.724-3.702c-.909-1.553-1.367-3.265-1.367-5.126 0-1.862.458-3.595 1.367-5.17a10.029 10.029 0 013.731-3.73c1.575-.91 3.308-1.368 5.205-1.368 1.898 0 3.63.458 5.206 1.375a10.132 10.132 0 013.73 3.73c.91 1.568 1.368 3.287 1.368 5.163 0 1.876-.458 3.573-1.368 5.133a9.971 9.971 0 01-3.737 3.702c-1.583.902-3.33 1.36-5.235 1.36-1.904 0-3.608-.458-5.184-1.367h.008zm8.033-3.852a5.472 5.472 0 002.02-2.076c.494-.881.744-1.855.744-2.922 0-1.067-.25-2.055-.744-2.936a5.56 5.56 0 00-2.027-2.083 5.386 5.386 0 00-2.807-.766 5.438 5.438 0 00-2.821.766 5.532 5.532 0 00-2.019 2.083c-.494.881-.745 1.862-.745 2.936 0 1.074.251 2.055.745 2.929a5.474 5.474 0 002.019 2.062c.852.501 1.79.752 2.821.752 1.031 0 1.969-.251 2.822-.752l-.008.007zM191.759 18.896c.766.258 1.51.637 2.234 1.131l-2.106 3.867c-.966-.68-1.961-1.024-2.978-1.024-.716.014-1.404.236-2.048.68-.644.444-1.167 1.06-1.575 1.862-.401.802-.616 1.725-.645 2.778V38.4h-4.74V18.903h4.074l.337 2.62c.544-.952 1.26-1.696 2.148-2.233.888-.53 1.897-.802 3.022-.802.744 0 1.503.129 2.269.394l.008.014zM197.301 30.266c.307 1.39.973 2.478 1.997 3.273 1.024.794 2.234 1.188 3.638 1.188 1.797 0 3.344-.594 4.632-1.783l2.27 3.294a10.078 10.078 0 01-3.208 1.99c-1.21.473-2.534.71-3.974.71-1.897 0-3.608-.459-5.141-1.368a9.787 9.787 0 01-3.601-3.71c-.874-1.56-1.303-3.264-1.303-5.112 0-1.847.408-3.587 1.224-5.155.816-1.561 1.955-2.8 3.415-3.709 1.454-.91 3.094-1.368 4.905-1.368 1.998 0 3.724.43 5.17 1.296a8.457 8.457 0 013.308 3.58c.752 1.526 1.131 3.266 1.131 5.227 0 .595-.036 1.146-.114 1.654h-14.364l.015-.007zm1.84-6.573c-.895.716-1.497 1.704-1.805 2.965h9.86c-.286-1.29-.845-2.285-1.683-2.986-.837-.702-1.897-1.053-3.172-1.053-1.274 0-2.305.358-3.2 1.067v.007zM219.139 38.415V12.273h9.43c2.506 0 4.798.572 6.881 1.718a13.053 13.053 0 014.948 4.719c1.217 1.997 1.826 4.21 1.826 6.637 0 2.428-.602 4.64-1.812 6.63-1.21 1.991-2.849 3.56-4.926 4.705-2.076 1.146-4.36 1.718-6.852 1.718h-9.488l-.007.015zm9.652-4.783c1.547 0 2.957-.358 4.232-1.081a7.826 7.826 0 002.993-2.965c.723-1.26 1.088-2.67 1.088-4.231s-.365-2.98-1.095-4.24a7.877 7.877 0 00-3.015-2.978c-1.281-.723-2.699-1.081-4.26-1.081h-4.561v16.576H228.791zM249.055 30.266c.308 1.39.974 2.478 1.998 3.273 1.023.794 2.234 1.188 3.637 1.188 1.797 0 3.344-.594 4.633-1.783l2.269 3.294c-.93.86-1.997 1.518-3.207 1.99-1.21.473-2.535.71-3.974.71-1.898 0-3.609-.459-5.141-1.368a9.79 9.79 0 01-3.602-3.71c-.866-1.56-1.303-3.264-1.303-5.112 0-1.847.408-3.587 1.224-5.155.817-1.561 1.955-2.8 3.416-3.709 1.453-.91 3.093-1.368 4.904-1.368 1.998 0 3.724.43 5.17 1.296a8.451 8.451 0 013.308 3.58c.759 1.526 1.132 3.266 1.132 5.227 0 .595-.036 1.146-.115 1.654h-14.363l.014-.007zm1.84-6.573c-.895.716-1.496 1.704-1.804 2.965h9.859c-.286-1.29-.845-2.285-1.682-2.986-.838-.702-1.898-1.053-3.172-1.053-1.275 0-2.306.358-3.201 1.067v.007zM282.056 19.855c1.504.91 2.693 2.148 3.58 3.702.888 1.554 1.332 3.265 1.332 5.127 0 1.862-.444 3.566-1.317 5.127a10.044 10.044 0 01-3.58 3.702 9.323 9.323 0 01-4.905 1.367c-1.239 0-2.363-.243-3.365-.737a8.15 8.15 0 01-2.621-2.02l-.337 2.292h-4.145V10.97h4.783v9.916c1.51-1.596 3.408-2.398 5.692-2.398 1.761 0 3.394.458 4.891 1.367h-.008zm-2.499 13.791a5.289 5.289 0 001.984-2.026c.487-.867.723-1.84.723-2.922 0-1.08-.243-2.055-.723-2.928a5.285 5.285 0 00-1.991-2.055 5.433 5.433 0 00-2.792-.745c-1.017 0-1.969.25-2.829.745a5.373 5.373 0 00-2.026 2.055c-.494.873-.745 1.847-.745 2.928s.251 2.048.745 2.915a5.397 5.397 0 002.026 2.026 5.617 5.617 0 002.829.737c1.031 0 1.962-.243 2.799-.723v-.007zM295.374 38.415h-4.761V23.27h-2.793v-4.375h2.771v-4.654l4.783-1.131v5.785h4.297v4.375h-4.297v15.144zM315.982 38.415h-5.041v-21.43h-7.662V12.28h20.386v4.704h-7.683v21.43zM326.672 37.584a10.195 10.195 0 01-3.723-3.702c-.91-1.553-1.368-3.265-1.368-5.126 0-1.862.458-3.595 1.368-5.17a10.026 10.026 0 013.73-3.73c1.575-.91 3.308-1.368 5.206-1.368 1.897 0 3.637.458 5.205 1.375a10.194 10.194 0 013.731 3.73c.909 1.568 1.367 3.287 1.367 5.163 0 1.876-.458 3.573-1.367 5.133a9.981 9.981 0 01-3.738 3.702c-1.583.902-3.33 1.36-5.234 1.36-1.905 0-3.609-.458-5.184-1.367h.007zm8.034-3.852c.852-.501 1.518-1.196 2.019-2.076.494-.881.745-1.855.745-2.922 0-1.067-.251-2.055-.745-2.936a5.55 5.55 0 00-2.026-2.083 5.409 5.409 0 00-2.807-.766 5.435 5.435 0 00-2.821.766 5.527 5.527 0 00-2.02 2.083c-.494.881-.744 1.862-.744 2.936 0 1.074.25 2.055.744 2.929a5.469 5.469 0 002.02 2.062c.852.501 1.79.752 2.821.752 1.031 0 1.969-.251 2.821-.752l-.007.007zM359.588 10.97h4.783v27.438h-4.146l-.337-2.292a8.246 8.246 0 01-2.62 2.02c-1.003.486-2.127.737-3.366.737a9.335 9.335 0 01-4.904-1.368 10.038 10.038 0 01-3.581-3.701c-.88-1.554-1.317-3.266-1.317-5.127 0-1.862.444-3.566 1.332-5.127.888-1.554 2.083-2.792 3.58-3.702a9.251 9.251 0 014.89-1.367c2.284 0 4.182.802 5.693 2.398v-9.917l-.007.008zm-2.456 22.669a5.347 5.347 0 002.026-2.026c.494-.86.745-1.834.745-2.915 0-1.08-.251-2.055-.745-2.928a5.422 5.422 0 00-2.026-2.055 5.55 5.55 0 00-2.829-.745c-1.031 0-1.947.25-2.792.745a5.334 5.334 0 00-1.991 2.055c-.487.873-.723 1.847-.723 2.928s.243 2.055.723 2.922a5.193 5.193 0 001.984 2.026c.837.48 1.768.723 2.799.723a5.563 5.563 0 002.829-.737v.007zM383.675 18.917h4.131v19.498h-4.146l-.336-2.291a8.253 8.253 0 01-2.621 2.019c-1.002.487-2.126.737-3.365.737a9.34 9.34 0 01-4.905-1.367 10.036 10.036 0 01-3.58-3.702c-.881-1.554-1.318-3.265-1.318-5.127 0-1.862.444-3.566 1.332-5.127.888-1.553 2.084-2.792 3.58-3.702a9.255 9.255 0 014.891-1.367c1.267 0 2.406.25 3.415.745a8.204 8.204 0 012.635 2.047l.301-2.363h-.014zm-3.108 14.722a5.347 5.347 0 002.026-2.027c.494-.859.745-1.832.745-2.914 0-1.08-.251-2.055-.745-2.928a5.421 5.421 0 00-2.026-2.055 5.544 5.544 0 00-2.828-.745 5.4 5.4 0 00-2.793.745 5.33 5.33 0 00-1.99 2.055c-.487.873-.723 1.847-.723 2.928s.243 2.055.723 2.922a5.182 5.182 0 001.983 2.026c.838.48 1.769.723 2.8.723a5.557 5.557 0 002.828-.737v.007zM400.043 45.017h-5.062l2.749-6.638-7.847-19.476h5.169l5.02 13.955 5.04-13.955h5.249l-10.325 26.12.007-.007z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#97CA48",
                        d: "M40.155 9.967c-.158.029-.322.014-.48.014.158-.021.322-.035.48-.014zM40.548 9.953a.48.48 0 01-.3.007.71.71 0 01.3-.007z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#878787",
                        d: "M24.538 32.056c.014-.186-.014-.415.014-.644.022-.129-.085-.1-.157-.107a5.538 5.538 0 01-1.325-.237 2.83 2.83 0 01-.809-.394c-.1-.064-.114-.128-.078-.229.178-.508.358-1.017.53-1.525.135-.387.128-.387.493-.172.609.365 1.275.559 1.99.502.402-.036.789-.144 1.096-.452.344-.35.459-.988-.107-1.41-.35-.258-.759-.394-1.167-.516-.659-.193-1.296-.45-1.833-.888a2.25 2.25 0 01-.58-.78c-.308-.645-.28-1.31-.1-1.97.179-.658.587-1.188 1.124-1.61.272-.215.573-.358.88-.501.1-.043.137-.108.137-.215V19.64c0-.121 0-.2.179-.214.522-.036 1.045-.108 1.568-.165.143-.014.2.021.193.179-.007.38 0 .759 0 1.146 0 .107.014.157.136.164.444.036.88.093 1.296.265.186.079.365.165.544.244.086.043.115.1.072.2-.215.573-.43 1.153-.637 1.726-.043.122-.1.129-.208.079-.437-.23-.888-.423-1.39-.466-.486-.043-.959-.014-1.381.272-.422.287-.501.96.036 1.268.272.157.565.279.866.38.423.142.86.271 1.26.472.852.436 1.511 1.045 1.669 2.047.064.409.057.824-.036 1.24-.172.765-.594 1.367-1.182 1.868-.3.258-.644.437-1.002.602-.107.05-.129.107-.129.207v1.353c0 .122-.036.158-.157.165-.48.036-.96.093-1.44.136-.043 0-.071.029-.107.043-.136.057-.265-.029-.265-.172v-.644l.007.021z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#878787",
                        d: "M10.375 12.724c-.086 0-.172-.008-.25-.015-1.203-.057-2.413-.2-3.616-.2a43.6 43.6 0 01-2.37-.244c-.609-.078-1.225-.143-1.826-.243-.73-.122-1.447-.28-2.177-.415-.05-.007-.136-.05-.129.071 0 .08.014.158.014.237v27.538c0 .072-.007.143-.014.215-.007.107.072.093.13.1 2.756.587 5.591.852 8.405 1.01 2.814.157 5.778.136 8.664-.05a78.059 78.059 0 011.826-.1c1.146-.072 2.291-.158 3.437-.266 1.54-.143 3.072-.343 4.604-.494 1.11-.143 2.22-.208 3.33-.35.816-.108 1.632-.137 2.455-.208l2.936-3.043 4.296-4.461.029-.029-4.34-10.218 4.977-8.012 1.761-2.835h-1.969c-.1.05-.2.036-.3.014h-.093a2.153 2.153 0 01-.48.014c-.272 0-.544.029-.81.029-.486 0-.973.036-1.46.057-1.74.072-3.48.215-5.212.365-1.103.1-2.213.208-3.316.323-1.69.171-3.372.35-5.055.53-.515.057-1.03.121-1.546.164-2.836.265-5.664.559-8.521.58-1.132 0-2.256-.014-3.38-.064zM33.746 27.56c-.229.888-.551 1.733-1.002 2.506-.53.91-1.153 1.725-1.92 2.434a9.318 9.318 0 01-3.336 2.034 8.738 8.738 0 01-2.098.43 7.028 7.028 0 01-1.289-.015 7.338 7.338 0 01-2.255-.616c-1.031-.465-1.905-1.167-2.642-2.062a7.696 7.696 0 01-1.239-2.112 9.134 9.134 0 01-.487-1.69c-.057-.28-.05-.58-.1-.86-.079-.493-.057-.98-.036-1.467.029-.802.186-1.59.423-2.356.157-.5.343-.995.565-1.468a9.199 9.199 0 01.988-1.604c.136-.171.265-.35.409-.515a9.411 9.411 0 012.398-2.07 8.528 8.528 0 012.707-1.088 8.987 8.987 0 011.224-.164 6.741 6.741 0 012.449.25 7.146 7.146 0 012.964 1.683 8.173 8.173 0 011.89 2.7c.344.787.552 1.625.645 2.498.036.373.079.738.072 1.11-.029.824-.115 1.633-.323 2.427l-.007.015z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#08C",
                        d: "M40.62.573L37.22.086l4.39 8.57L40.62.574zM52.184 1.64L49.313 0l-5.564 9.115 8.435-7.475zM43.155 4.174l-.616 5.192 2.255-5.356-1.64.164zM37.04 49.427l3.401.487-4.39-8.57.989 8.083zM25.476 48.36L28.355 50l5.563-9.115-8.442 7.475zM34.505 45.825l.616-5.19-2.256 5.348 1.64-.157zM56.244 12.982C54.719 11.507 45.89 10.79 45.89 10.79l-1.761 2.835-4.977 8.012 4.34 10.218-.03.029-4.296 4.46-2.935 3.044-.122.128 14.17 1.87c3.938.758 5.965 1.553 5.965 1.553V12.982z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H410.368V50H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (NoMoreDebtTodayLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/noMoreDebtTodayWrapper.tsx








const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function NoMoreDebtTodayWrapper({ children , boxShadow  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Debt Relief",
                    domain: "NoMoreDebtToday.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Debt Relief",
                    domain: "NoMoreDebtToday.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Find the Right debt relief For You",
                        boxShadow: boxShadow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);